import React, { useState } from 'react';
import {
  IconContainer,
  SearchFieldInput,
  StyledSearchFieldContainer,
  StyledTextLabel,
} from './styled.searchField';
import { CloseCircleDark } from './../../icons/CloseCircleDark';
import { ISearchField } from './../../../@types/searchField';
import { Body5 } from './../../typography';

export function SearchField ({
  icon,
  placeholderText,
  textValue,
  onChange,
  onClearTextValue,
  label,
}: ISearchField) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <>
      <StyledTextLabel>
        {label && <Body5 color="eerieBlack">{label}</Body5>}
      </StyledTextLabel>
      <StyledSearchFieldContainer isFocused={isFocused}>
        <IconContainer>{icon}</IconContainer>
        <SearchFieldInput
          type="text"
          value={textValue}
          placeholder={placeholderText}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
        {textValue && textValue.length > 0 && (
          <IconContainer onClick={onClearTextValue}>
            <CloseCircleDark />
          </IconContainer>
        )}
      </StyledSearchFieldContainer>
    </>
  );
}
